/*eslint-disable*/
import { HamburgerIcon } from "@chakra-ui/icons";
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import SidebarContent from "./SidebarContent";

function SidebarResponsive(props) {
  const { logoText, routes, ...rest } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  let hamburgerColor = useColorModeValue("slate.600", "slate.200");
  if (props.secondary === true) {
    hamburgerColor = "white";
  }

  const drawerBg = useColorModeValue(
    "rgba(255, 255, 255, 0.96)",
    "rgba(11, 19, 41, 0.96)"
  );
  const drawerBorder = useColorModeValue("slate.200", "whiteAlpha.100");

  return (
    <Flex
      display={{ sm: "flex", xl: "none" }}
      alignItems="center"
    >
      <HamburgerIcon
        color={hamburgerColor}
        w="20px"
        h="20px"
        ref={btnRef}
        cursor="pointer"
        onClick={onOpen}
        _hover={{ opacity: 0.8 }}
      />
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement="left"
        finalFocusRef={btnRef}
      >
        <DrawerOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
        <DrawerContent
          w="280px"
          maxW="280px"
          bg={drawerBg}
          backdropFilter="blur(20px)"
          borderRight="1px solid"
          borderColor={drawerBorder}
          p="0"
          shadow="2xl"
        >
          <DrawerCloseButton
            position="absolute"
            top="16px"
            right="16px"
            zIndex="10"
            _focus={{ boxShadow: "none" }}
            _hover={{ bg: "whiteAlpha.200" }}
          />
          <DrawerBody px="16px" py="16px" overflowY="auto">
            <SidebarContent
              routes={routes}
              logoText={logoText}
              onClose={onClose}
              {...rest}
            />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

export default SidebarResponsive;